var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron-left",
    width: "20px",
    height: "25px",
    viewBox: "0 0 38 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in/chevron/left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "chevron-left-1",
    points: "38 44 22 44 2.87325719e-13 22 22 0 38 0 15.5 22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-3",
    transform: "translate(-13.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-4",
    transform: "translate(13.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chevron-left-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "chevron-left-6",
    xlinkHref: "#chevron-left-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "chevron-left-7",
    fill: "#151515",
    xlinkHref: "#chevron-left-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-8",
    mask: "url(#chevron-left-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-9",
    transform: "translate(-13.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "chevron-left-10",
    fill: "#151515",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.6e46bbc2e8f47ee9436a57d60e1d7fdd.svg";
export { ForwardRef as ReactComponent };